import { render } from "./IconH2h.vue?vue&type=template&id=249e17b1&ts=true"
import script from "./IconH2h.vue?vue&type=script&lang=ts"
export * from "./IconH2h.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__